import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selected: [],
};

const orderSetHistorySlice = createSlice({
  name: "orderSetHistory",
  initialState,
  reducers: {
    setOrderSetSelection(state, action) {
      state.selected = action.payload;
    },
  },
});

export const { setOrderSetSelection } = orderSetHistorySlice.actions;

export default orderSetHistorySlice.reducer;
